import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Filter, Sliders } from 'feather-icons-react/build/IconComponents';
import { ImageWithBasePath } from 'Core/components';
import Select from 'react-select';
import { actions as inventoryActions } from './store/slice';
import { selectInventoryFilterVisible } from './store/selectors';

const { setFilterVisible, setSearchText } = inventoryActions;

const InventorySearch = ({ selectedType, handleTypeChange }) => {
  const dispatch = useDispatch();
  const filterVisible = useSelector(selectInventoryFilterVisible);
  const [searchText, setSearchTextValue] = useState('');

  const handleSearch = e => {
    const newSearchText = e.target.value;
    setSearchTextValue(newSearchText);

    // let searchTimeout;
    // clearTimeout(searchTimeout);
    // searchTimeout = setTimeout(() => {
    dispatch(setSearchText(newSearchText));
    // }, 300);
  };

  const toggleFilterVisibility = () => {
    const newVisibility = !filterVisible;
    dispatch(setFilterVisible(newVisibility));
  };

  const oldandlatestvalue = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
  ];

  // Filter button data
  const filterButtons = [
    { key: 'FG', label: 'FG', color: '#28a745', bgColor: '#d4edda' },
    { key: 'PL', label: 'PL', color: '#007bff', bgColor: '#d1ecf1' },
    { key: 'IN', label: 'IN', color: '#ffc107', bgColor: '#fff3cd' },
    { key: 'Others', label: 'Others', color: '#6c757d', bgColor: '#e2e3e5' }
  ];

  return (
    <>
      <div className="search-set">
        <div className="search-input" style={{ display: 'flex', alignItems: 'center' }}>
          <Link to="#" className="btn btn-searchset">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-search"
            >
              <circle cx={11} cy={11} r={8} />
              <line x1={21} y1={21} x2="16.65" y2="16.65" />
            </svg>
          </Link>
          <div id="DataTables_Table_0_filter" className="dataTables_filter" style={{ marginRight: '1rem' }}>
            <label>
              {' '}
              <input
                type="search"
                className="form-control form-control-sm"
                placeholder="Search"
                aria-controls="DataTables_Table_0"
                value={searchText}
                onChange={handleSearch}
              />
            </label>
          </div>
          
          {/* Material Type Filter Buttons */}
          <div style={{ 
            display: 'inline-flex', 
            gap: '0.75rem', 
            verticalAlign: 'middle', 
            alignItems: 'center',
            marginLeft: '1rem'
          }}>
            {filterButtons.map((button) => (
              <button
                key={button.key}
                type="button"
                onClick={() => handleTypeChange(button.key)}
                style={{
                  padding: '0.5rem 1rem',
                  border: selectedType === button.key
                    ? `2px solid ${button.color}` 
                    : '2px solid #e0e0e0',
                  borderRadius: '8px',
                  backgroundColor: selectedType === button.key
                    ? button.bgColor 
                    : '#ffffff',
                  color: selectedType === button.key
                    ? button.color 
                    : '#6c757d',
                  fontWeight: selectedType === button.key ? '600' : '400',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease-in-out',
                  minWidth: '60px',
                  fontSize: '0.875rem',
                  boxShadow: selectedType === button.key
                    ? '0 2px 8px rgba(0,0,0,0.15)' 
                    : '0 1px 3px rgba(0,0,0,0.1)',
                  transform: selectedType === button.key ? 'translateY(-1px)' : 'translateY(0)'
                }}
                onMouseEnter={(e) => {
                  if (selectedType !== button.key) {
                    e.target.style.backgroundColor = button.bgColor;
                    e.target.style.color = button.color;
                    e.target.style.borderColor = button.color;
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedType !== button.key) {
                    e.target.style.backgroundColor = '#ffffff';
                    e.target.style.color = '#6c757d';
                    e.target.style.borderColor = '#e0e0e0';
                  }
                }}
              >
                {button.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="search-path">
        <Link
          to="#"
          className={`btn btn-filter ${filterVisible ? 'setclose' : ''}`}
          id="filter_search"
          onClick={e => {
            e.preventDefault();
            toggleFilterVisibility();
          }}
        >
          <Filter className="filter-icon" />
          <span>
            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
          </span>
        </Link>
      </div>
      <div className="form-sort" style={{ display: 'none' }}>
        <Sliders className="info-img" />
        <Select
          className="img-select"
          classNamePrefix="react-select"
          options={oldandlatestvalue}
          placeholder="Newest"
        />
      </div>
    </>
  );
};

export default InventorySearch;
